import type { FC } from 'react';
import { useStrategySelectorContext } from './StrategySelectorContext';
import styles from './StrategySelector.module.css';

interface StrategySelectorListProps {
  emptyMessage?: string;
}

export const StrategySelectorList: FC<StrategySelectorListProps> = ({ emptyMessage = 'No strategies available.' }) => {
  const { strategies, selectedKeys, onToggle, expanded } = useStrategySelectorContext();

  if (!expanded) return null;

  if (strategies.length === 0) {
    return <p className={styles.emptyStrategies}>{emptyMessage}</p>;
  }

  return (
    <div className={styles.strategyList}>
      {strategies.map((strategy) => (
        <div key={strategy.strategyKey} className={styles.strategyRow}>
          <label className={styles.strategyToggle}>
            <input
              type="checkbox"
              checked={selectedKeys.has(strategy.strategyKey)}
              onChange={() => onToggle(strategy.strategyKey)}
            />
            <span className={styles.toggleTrack} />
          </label>
          <div className={styles.strategyInfo}>
            <p className={styles.strategyName}>{strategy.name}</p>
            <p className={styles.strategyDescription}>{strategy.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
